// React
import React, { memo } from "react";
// Libraries
import cn from "classnames";
// Components
import { Field, Input } from "components";
// Resources
import inputStyles from "../Input/Input.module.scss";

export const InputTextarea = memo(
  ({ name, hasError, resize, rows = 4, ...props }: InputTextareaProps): JSX.Element => (
    <Input hasError={hasError}>
      <textarea
        className={cn(
          inputStyles.input__native,
          inputStyles["input__native--text"],
          inputStyles["input__native--textarea"],
          {
            [inputStyles["input__native--resize-disabled"]]: !resize,
          },
        )}
        id={name}
        name={name}
        rows={rows}
        {...props}
      />
    </Input>
  ),
);
InputTextarea.displayName = "InputTextarea";

export const FieldTextarea = memo(
  ({ error, inputProps, ...props }: FieldTextareaProps): JSX.Element => (
    <Field error={error} labelFor={inputProps.name} {...props}>
      <InputTextarea hasError={!!error} {...inputProps} />
    </Field>
  ),
);
FieldTextarea.displayName = "FieldTextarea";
